import { CASE_STUDIES } from 'containers/CaseStudyPage/constants'
import { getPageSEO } from 'helpers/seo'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'
import { GetStaticPaths } from 'next'
import dynamic from 'next/dynamic'

const CaseStudyPage = dynamic(() =>
  import('containers/CaseStudyPage').then((res) => res.CaseStudyPage)
)

export default withAuth(CaseStudyPage, {
  LoggedOutComponent: CaseStudyPage,
  naiveCheck: true,
})

export const getStaticProps = withAuthServerSideProps(() =>
  getPageSEO('case-studies')
)

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: CASE_STUDIES.map(({ name }) => ({
      params: { companyName: name.toString() },
    })),
    fallback: true,
  }
}
